import type { CSSObject } from '@emotion/react'
import { Color, Spacing } from '@opallabs/gem'
import { WithRequiredTheme } from '@opallabs/lapidary'

type StyleProps = WithRequiredTheme

export const preview = ({ theme }: StyleProps): CSSObject => ({
  display: 'flex',
  blockSize: 60,
  flexFlow: 'nowrap',
  gap: Spacing.S,
  alignItems: 'center',
  inlineSize: '100%',

  img: {
    inlineSize: 80,
    border: `1px solid ${Color[theme].Surface.N600}`,
  },
})

export const fileInfo = ({ theme }: StyleProps): CSSObject => ({
  flex: '1',
  minInlineSize: 0,
  color: Color[theme].Text.Default,

  '& > span': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
})

export const actions = ({ theme }: StyleProps): CSSObject => ({
  display: 'flex',
  flexWrap: 'nowrap',
  gap: Spacing.XS,
  alignItems: 'center',

  button: {
    color: Color[theme].Text.Warning,
  },
})
